import { render, staticRenderFns } from "./Incidencia.vue?vue&type=template&id=756b48f2"
import script from "./Incidencia.vue?vue&type=script&lang=js"
export * from "./Incidencia.vue?vue&type=script&lang=js"
import style0 from "./Incidencia.vue?vue&type=style&index=0&id=756b48f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports